export const NINJAONE_OAUTH_CALLBACK_MESSAGE = "theo:ninjaone-oauth-callback";
export const NINJAONE_OAUTH_SCOPES = "monitoring management offline_access";

export interface NinjaOneOAuthCallbackMessage {
  type: typeof NINJAONE_OAUTH_CALLBACK_MESSAGE;
  code?: string;
  state?: string;
  error?: string;
  errorDescription?: string;
}

export interface NinjaOneOAuthRequest {
  instanceUrl: string;
  clientId: string;
  clientSecret: string;
  redirectUri: string;
  state: string;
}

export function getNinjaOneRedirectUri(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}/ninjaone/oauth/callback`;
  }
  return "/ninjaone/oauth/callback";
}

export function normalizeNinjaOneInstanceUrl(raw: string): string {
  const value = String(raw || "").trim().replace(/\/+$/, "");
  if (!value) return "";
  if (!/^https:\/\//i.test(value)) {
    return `https://${value}`;
  }
  return value;
}

export function createNinjaOneOAuthState(): string {
  const bytes = new Uint8Array(16);
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  }
  return `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`;
}

export function buildNinjaOneAuthorizationUrl(request: NinjaOneOAuthRequest): string {
  const instanceUrl = normalizeNinjaOneInstanceUrl(request.instanceUrl);
  const url = new URL(`${instanceUrl}/oauth/authorize`);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("client_id", request.clientId);
  url.searchParams.set("redirect_uri", request.redirectUri);
  url.searchParams.set("scope", NINJAONE_OAUTH_SCOPES);
  url.searchParams.set("state", request.state);
  return url.toString();
}

export function asNinjaOneOAuthCallbackMessage(data: unknown): NinjaOneOAuthCallbackMessage | null {
  if (!data || typeof data !== "object") return null;
  const message = data as Record<string, unknown>;
  if (message.type !== NINJAONE_OAUTH_CALLBACK_MESSAGE) return null;
  return {
    type: NINJAONE_OAUTH_CALLBACK_MESSAGE,
    code: typeof message.code === "string" ? message.code : undefined,
    state: typeof message.state === "string" ? message.state : undefined,
    error: typeof message.error === "string" ? message.error : undefined,
    errorDescription: typeof message.errorDescription === "string" ? message.errorDescription : undefined,
  };
}
